export class Optimizado{
    regla:string;
    original:string;
    optimizado:string;

    constructor(regla:string,original:string,signo:string){
        this.regla = regla;
        this.original = original;
        this.optimizado = signo;
    }

}